import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpEventType
} from '@angular/common/http';

import { tap } from 'rxjs/operators';
import {Observable} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar"; // fancy pipe-able operators

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

  constructor(private _snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
       tap({
          next: (event) => {
              if(event.type === HttpEventType.Response) {
                console.log('LoggingInterceptor: ', event);
              }
            },
          error: (error) => {
            console.error('LoggingInterceptor: ', error);
            this._snackBar.open(`${error.error?.message} ${error.message}  `, 'Close', {
              duration: 0,
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
              panelClass: ['error-snackbar'],
            });
            },
    }));
  }
}
